import KeyContactInformation from "../../components/KeyContactInformation";
import ScrollToHashElement from "../../components/ScrollToHashElement";
import Breadcrumbs from "../../components/Breadcrumbs";
import "./Contacts.scss";
import { getLocalizedValueSync } from "../../services/localizationService";

const Contacts = () => {
  const localizedBreadcrumb = getLocalizedValueSync("CA.ContactsPage.breadcrumb") || "";

  return (
    <div>
      <Breadcrumbs current={localizedBreadcrumb} />
      <div className="contacts-page">
        <KeyContactInformation />
        <ScrollToHashElement />
      </div>
    </div>
  )
}

export default Contacts